import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GroupPopularTopicsLoadAction } from '../../domains/groupPopularTopicsLoad/actions.types';

import { GroupPopularTopics } from './types';

export type GroupPopularTopicsAction = GroupPopularTopicsLoadAction;

const initialState: GroupPopularTopics = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupPopularTopics, GroupPopularTopicsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_POPULAR_TOPICS.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_POPULAR_TOPICS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_POPULAR_TOPICS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupPopularTopics);
    default:
      return state;
  }
};

export default reducer;
